import React, { useContext, useEffect, useState } from "react";
import logo from "../../assets/images/spec-logo.png";
import flight from "../../assets/images/spec-flight.png";
import poerdbyLogo from "../../assets/images/vfx-powerdby.png";
import { Button, Form, Input } from "antd";
import { appMessage, dismissAllToasts } from "../../hooks/useAppMessage";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { LoginAPI } from "../../API/LoginAPI";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ContextData } from "../../ContextData";

const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not valid!",
  },
};

export default function Login() {
  const [form] = Form.useForm();
  const { setUserRole } = useContext(ContextData);
  const navigate = useNavigate();
  const [loadingState, setLoadingState] = useState(false);
  const onFinish = (values) => {
    const bodyData = {
      email: values.email.trim(),
      password: values.password.trim(),
    };
    loginFun(bodyData);
  };

  async function loginFun(bodydata) {
    setLoadingState(true);
    dismissAllToasts();
    await LoginAPI.login(bodydata)
      .then((res) => {
        if (res.data.status === true) {
          if (res.data?.redirect_reset === true) {
            localStorage.setItem("resetPassword", bodydata.email);
            localStorage.setItem("resetPass", bodydata.password);
            navigate("/reset-password");
          } else {
            localStorage.setItem("SWAAccessToken", res.data?.token);
            localStorage.setItem("loged-user", res.data?.username);
            localStorage.setItem("user-first-name", res.data?.first_name);
            localStorage.setItem("user-last-name", res.data?.last_name);
            const roles = res.data?.groups;
            if (roles) {
              const isAdmin =
                roles.includes("is_superadmin") ||
                roles.includes("is_admin") ||
                roles.includes("is_superuser");

              setUserRole(isAdmin ? "admin" : null);
              localStorage.setItem("userRole", isAdmin ? "admin" : "");
            } else {
              setUserRole(null);
              localStorage.setItem("userRole", "");
            }

            navigate("/");
          }
        } else {
          appMessage.error(res.data?.message, 8);
        }
      })
      .catch(() => appMessage.error("Internal Server Error", 8))
      .finally(() => setLoadingState(false));
  }

  useEffect(() => {
    localStorage.setItem("resetPassword", "");
    localStorage.setItem("resetPass", "");
  }, []);

  const handleEmailChange = (e) => {
    const trimmedValue = e.target.value.trim();
    form.setFieldsValue({ email: trimmedValue });
  };

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        background: "#fff",
      }}
    >
      <Helmet>
        <title>SpecOptimizer</title>
      </Helmet>
      <div
        style={{
          overflow: "hidden",
          background: "linear-gradient(180deg, #D3E4FF 0%, #FFFFFF 100%)",
          height: "100%",
          display: "flex",
          alignItems: "stretch",
        }}
      >
        <div className="login_left_div">
          <div style={{ margin: "150px 0px -20px 50px", maxWidth: "600px" }}>
            <h1 className="login_head2 stroke_text">Welcome to</h1>
            <h1 className="login_head" style={{ marginLeft: "5rem" }}>
              SpecOptimizer
            </h1>
            {/* <p className='login_paragraph'>SpecOptimizer is proud to offer one-of-a-kind value and Hospitality at more than 120 airports across 11 countries.</p> */}
          </div>
          <img
            className="plane_img"
            src={flight}
            style={{
              width: "855px",
              marginLeft: "80px",
              transform: "rotate(356deg)",
            }}
            alt={`img_${flight}`}
          />
        </div>
        <div className="login_right_div">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
              width: "60%",
              zIndex: 999,
            }}
          >
            <div style={{ textAlign: "center" }}>
              <img
                src={logo}
                style={{ marginBottom: "10px", width: "250px" }}
                alt={`img_${logo}`}
              />
            </div>
            <Form
              form={form}
              name="normal_login"
              className="login-form"
              initialValues={{}}
              onFinish={onFinish}
              autoComplete="off"
              layout="vertical"
              requiredMark="optional"
              validateMessages={validateMessages}
            >
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, type: "email" }]}
              >
                <Input
                  name="email"
                  size="large"
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  onChange={handleEmailChange}
                />
              </Form.Item>
              <Form.Item
                name="password"
                label="Password"
                rules={[{ required: true }]}
              >
                <Input.Password
                  name="password"
                  size="large"
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                />
              </Form.Item>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "-10px",
                }}
              >
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/forgot-password");
                  }}
                >
                  Forgot password
                </a>
              </div>

              <Form.Item style={{ marginTop: "10px" }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  style={{ width: "100%", marginTop: "20px" }}
                  loading={loadingState}
                >
                  Log in
                </Button>
              </Form.Item>
            </Form>
            <div style={{ textAlign: "center" }}>
              <img
                src={poerdbyLogo}
                style={{ marginTop: "50px", width: "120px" }}
                alt={`img_${poerdbyLogo}`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
